import { useCallback, useState } from 'react';

export default function useToggle(initial?: boolean) {
  const [val, setVal] = useState(!!initial);
  const on = useCallback(() => {
    setVal(true);
  }, []);
  const off = useCallback(() => {
    setVal(false);
  }, []);
  const toggle = useCallback(() => {
    setVal((prev) => !prev);
  }, []);
  const set = useCallback((bool: boolean) => {
    setVal(bool);
  }, []);
  return {
    isOn: val,
    on,
    off,
    toggle,
    set,
  };
}
